import { FC } from 'react'

import RightArrowIcon from 'src/Assets/Svg/pages-icons/RightArrow.svg?react'
import {
  GreyTextButton,
  GreyTextButtonProps,
} from 'src/Components/Buttons/GreyTextButton'
import { IconButton } from 'src/Components/Buttons/IconButton'

export type DetailsButtonProps = Pick<
  GreyTextButtonProps,
  'onClick' | 'className' | 'disabled' | 'loading' | 'children' | 'id'
> & {
  variant?: 'text' | 'icon'
}

export const DetailsButton: FC<DetailsButtonProps> = ({
  variant = 'text',
  children = 'Details',
  loading,
  ...rest
}) => {
  if (variant === 'icon') {
    return (
      <IconButton {...rest}>
        <RightArrowIcon />
      </IconButton>
    )
  }

  return (
    <GreyTextButton loading={loading} {...rest}>
      {children}
    </GreyTextButton>
  )
}
